import { render, staticRenderFns } from "./TemplatePreviewModal.vue?vue&type=template&id=4838f8e7&"
import script from "./TemplatePreviewModal.vue?vue&type=script&lang=ts&"
export * from "./TemplatePreviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports